import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import colors from '@app/constants/colors';
import LanguageSwitch from './components/LanguageSwitch';
import LoginHeaderItem from './components/LoginHeaderItem';
import Menu from './components/Menu';
import NavMenu from './components/NavMenu';

class Header extends React.Component {
  state = {
    isMenuOpen: false,
  };

  burgerRef = React.createRef();

  onClickHandler = () => {
    const { isMenuOpen } = this.state;
    this.setState({ isMenuOpen: !isMenuOpen });
  };

  render() {
    const { isLoggedIn } = this.props;
    const { isMenuOpen } = this.state;

    return (
      <React.Fragment>
        <HeaderContainer>
          <LeftMenu>
            {isLoggedIn && (
              <Humburger ref={this.burgerRef} onClick={this.onClickHandler}>
                <HamburgerLine isMenuOpen={isMenuOpen} />
                <HamburgerLine isMenuOpen={isMenuOpen} />
                <HamburgerLine isMenuOpen={isMenuOpen} />
                <HamburgerLine isMenuOpen={isMenuOpen} />
              </Humburger>
            )}
            <LanguageSwitch isShowOnSmall={!isLoggedIn} />
          </LeftMenu>
          {
            isLoggedIn && <Menu />
          }
          <LoginHeaderItem />
        </HeaderContainer>
        {
          isLoggedIn && (
            <NavMenu
              onClickHandler={this.onClickHandler}
              burgerElement={this.burgerRef.current}
              isMenuOpen={isMenuOpen}
            />
          )
        }
      </React.Fragment>
    );
  }
}

Header.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ user: { isLoggedIn } }) => ({
  isLoggedIn,
});

export default connect(mapStateToProps)(Header);

const HeaderContainer = styled.header`
  height: 75px;
  display: flex;
  position: fixed;
  align-items: center;
  justify-content: space-between;
  color: ${colors.CERULEAN};
  font-size: 15px;
  box-shadow: 0 3px 5px 0 rgba(0,0,0,.1);
  top: 0;
  width: 100%;
  z-index: 999;
  background: white;
  padding: 10px 25px;
  flex: 0 0 auto;
`;

const LeftMenu = styled.div`
  display: flex;
`;

const Humburger = styled.div`
  margin-right: 20px;
  display: none;
  position: relative;
  height: 39px;
  width: 50px;
  cursor: pointer;
  @media (max-width: 979px) {
    display: block;
  }
`;

const HamburgerLine = styled.span`
  display: block;
  position: absolute;
  height: 9px;
  width: 100%;
  border-radius: 10px;
  opacity: 1;
  left: 0;
  transition: .25s ease-in-out;
  
  &:nth-child(1) {
    top: ${({ isMenuOpen }) => (isMenuOpen ? '15px' : 0)};
    background-image: linear-gradient(#fe6e23, #fd5d21);
  }
  
  &:nth-child(1), :nth-child(4) {
    width: ${({ isMenuOpen }) => (isMenuOpen ? '0%' : '100%')};
    left: ${({ isMenuOpen }) => (isMenuOpen ? '50%' : 0)};
  }

  &:nth-child(2), :nth-child(3) {
    top: 15px;
    background-image: linear-gradient(#fe4e22, #fd3e20);
  }
  
  &:nth-child(2) {
    transform: ${({ isMenuOpen }) => (isMenuOpen ? 'rotate(45deg)' : 'rotate(0deg)')};
  }
  
  &:nth-child(3) { 
    transform: ${({ isMenuOpen }) => (isMenuOpen ? 'rotate(-45deg)' : 'rotate(0deg)')};
  }

  &:nth-child(4) {
    top: ${({ isMenuOpen }) => (isMenuOpen ? '15px' : '30px')};
    background-image: linear-gradient(#fe2d21, #fd171f);
  }
`;
